module.exports = __webpack_public_path__ + "img/ep3-2-4.0195ac0e.png";